import { parseNumber } from 'intl-utils';
import { fetch } from 'utils';

onLoad();

export function onLoad(context = document) {
    const cart = document.getElementById('cart');
    let timer, quantity = 0;

    document.addEventListener('incrementQuantity', e => {
        // Make sure the element is enabled.
        if (!e.target.classList.contains('cursor-pointer'))
            return;

        // Increment the displayed quantity.
        e.detail.item.quantity += e.detail.quantity;

        // Increment the quantity to update (this is the quantity changed since it was last pushed).
        quantity += e.detail.quantity;

        // Update the quantity on the server.
        updateQuantity(e.detail.item);
    });

    document.addEventListener('updateQuantity', e => {
        const originalQuantity = e.detail.item.quantity;

        // Update the displayed quantity.
        e.detail.item.quantity = parseNumber(e.target.value);

        // Increment the quantity to update (this is the quantity changed since it was last pushed).
        quantity += e.detail.item.quantity - originalQuantity;

        // Update the quantity on the server.
        updateQuantity(e.detail.item);
    });

    function updateQuantity(item) {
        // Make sure the user has stopped clicking the increment button before pushing the changes.
        if (timer)
            clearTimeout(timer);

        timer = setTimeout(async () => {
            // Disable the buttons.
            context.querySelectorAll('.increment-quantity, .quantity').forEach(element => element.classList.remove('cursor-pointer'));

            // Update the quantity.
            await handleResponse(await fetch(`/api/cart/${item.id}?quantity=${quantity}`, {
                method: 'PUT'
            }));

            // Reset the quantity.
            quantity = 0;

            // Enable the buttons.
            context.querySelectorAll('.increment-quantity, .quantity').forEach(element => element.classList.add('cursor-pointer'));
        }, 500);
    }

    document.addEventListener('removeItem', async e => {
        await handleResponse(await fetch(`/api/cart/${e.detail.id}`, {
            method: 'DELETE'
        }));
    });

    async function handleResponse(response) {
        const data = await response.json();

        cart.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: data }));
    }
}